import axios from 'axios/index';
import { server_connection } from 'config';
// export const GET_EVENTS = '[CALENDAR APP] GET EVENTS';
export const OPEN_NEW_EVENT_DIALOG = '[CALENDAR APP] OPEN NEW EVENT DIALOG';
export const CLOSE_NEW_EVENT_DIALOG = '[CALENDAR APP] CLOSE NEW EVENT DIALOG';
export const OPEN_EDIT_EVENT_DIALOG = '[CALENDAR APP] OPEN EDIT EVENT DIALOG';
export const CLOSE_EDIT_EVENT_DIALOG = '[CALENDAR APP] CLOSE EDIT EVENT DIALOG';
// export const ADD_EVENT = '[CALENDAR APP] ADD EVENT';
export const UPDATE_EVENT = '[CALENDAR APP] UPDATE EVENT';
// export const REMOVE_EVENT = '[CALENDAR APP] REMOVE EVENT';
export const RESIZE_EVENT = '[CALENDAR APP] RESIZE EVENT';

export const TOGGLE_EVENT_CALENDAR = '[CALENDAR APP] TOGGLE EVENT CALENDAR';

// export function getEvents() {
//     return async (dispatch, getState) => {
//         await fetch(server_connection + '/lesson/data/' + '1')
//             .then((response) => response.json())
//             .then((relatedData) => {
//                 dispatch({
//                     type: GET_EVENTS,
//                     payload: relatedData.assignments
//                 })
//             })
//     }
// }

// export function getEvents(modelName, model_id) {
//     return async (dispatch, getState) => {
//         await fetch(server_connection + '/' + modelName + '/data/' + model_id)
//             .then((response) => response.json())
//             .then((relatedData) => {
//                 dispatch({
//                     type: GET_EVENTS,
//                     payload: relatedData.assignments
//                 })
//             })
//     }
// }

export function openNewEventDialog(data) {
    return {
        type: OPEN_NEW_EVENT_DIALOG,
        data
    }
}

export function closeNewEventDialog() {
    return {
        type: CLOSE_NEW_EVENT_DIALOG
    }
}

export function openEditEventDialog(data) {
    return {
        type: OPEN_EDIT_EVENT_DIALOG,
        data
    }
}

export function closeEditEventDialog() {
    return {
        type: CLOSE_EDIT_EVENT_DIALOG
    }
}


// export function addEvent(newEvent) {
//     return (dispatch, getState) => {

//         const request = axios.post('/api/calendar-app/add-event', {
//             newEvent
//         });

//         return request.then((response) =>
//             Promise.all([
//                 dispatch({
//                     type: ADD_EVENT
//                 })
//             ]).then(() => dispatch(getEvents()))
//         );
//     };
// }

export function updateEvent(event) {
    // console.log('ACTION', event)
    return {
        type: UPDATE_EVENT,
        payload: event
    }
    // return (dispatch, getState) => {

    // const request = axios.post('/api/calendar-app/update-event', {
    //     event
    // });


    // return request.then((response) =>
    //     Promise.all([
    //         dispatch({
    //             type: UPDATE_EVENT
    //         })
    //     ]).then(() => dispatch(getEvents()))
    // );
    // };
}

export function resizeEvent(event) {
    return {
        type: RESIZE_EVENT,
        payload: {event: event}
    }
}

// export function removeEvent(eventId) {
//     return (dispatch, getState) => {

//         const request = axios.post('/api/calendar-app/remove-event', {
//             eventId
//         });

//         return request.then((response) =>
//             Promise.all([
//                 dispatch({
//                     type: REMOVE_EVENT
//                 })
//             ]).then(() => dispatch(getEvents()))
//         );
//     };
// }

export function toggleEventCalendar(eventObj, action_type) {
    return {
        type: TOGGLE_EVENT_CALENDAR,
        payload: {eventObj: eventObj, action_type: action_type}
    }
}


// WEBPACK FOOTER //
// src/main/content/company/store/actions/events.actions.js